import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Shield } from "lucide-react";

interface PrivacySettings {
  hideComments: boolean;
  hideLikes: boolean;
  hidePosts: boolean;
  privateProfile: boolean;
}

interface PrivacySectionProps {
  settings: PrivacySettings;
  onSettingChange: (setting: string, value: boolean) => void;
}

export const PrivacySection = ({ settings, onSettingChange }: PrivacySectionProps) => {
  const privacyOptions = [
    {
      key: 'hideComments',
      label: 'Hide Comments',
      description: 'Hide comments on your prompts from other users',
    },
    {
      key: 'hideLikes',
      label: 'Hide Likes',
      description: 'Hide likes count on your prompts',
    },
    {
      key: 'hidePosts',
      label: 'Hide Posts',
      description: 'Make your prompts private (only visible to you)',
    },
    {
      key: 'privateProfile',
      label: 'Private Profile',
      description: 'Hide your profile from search and discovery',
    },
  ];

  return (
    <Card className="border-border/50 bg-card/50 backdrop-blur-sm">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Shield className="h-5 w-5 text-primary" />
          Privacy
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {privacyOptions.map((option) => (
          <div key={option.key} className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-base">{option.label}</Label>
              <p className="text-sm text-muted-foreground">
                {option.description}
              </p>
            </div>
            <Switch
              checked={settings[option.key as keyof PrivacySettings]}
              onCheckedChange={(checked) => onSettingChange(option.key, checked)}
            />
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
